import { render, staticRenderFns } from "./WorkerAdd.vue?vue&type=template&id=32e73c9c"
import script from "./WorkerAdd.vue?vue&type=script&lang=ts"
export * from "./WorkerAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports